module.exports = __webpack_public_path__ + "fonts/DINPro.2888b1d2.woff2";